import { type Health, HEALTH_PATH, healthSchema } from '@baby-tracker/contracts';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiGet } from '../lib/api-client.js';

export const healthQueryKey = ['health'] as const;

export function useHealth(): UseQueryResult<Health> {
    return useQuery({
        queryKey: healthQueryKey,
        queryFn: ({ signal }) => apiGet(HEALTH_PATH, healthSchema, { signal }),
    });
}
